import { render, staticRenderFns } from "./mnemonic.vue?vue&type=template&id=151fcf52&scoped=true&"
import script from "./mnemonic.vue?vue&type=script&lang=js&"
export * from "./mnemonic.vue?vue&type=script&lang=js&"
import style0 from "./mnemonic.vue?vue&type=style&index=0&id=151fcf52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fcf52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('151fcf52')) {
      api.createRecord('151fcf52', component.options)
    } else {
      api.reload('151fcf52', component.options)
    }
    module.hot.accept("./mnemonic.vue?vue&type=template&id=151fcf52&scoped=true&", function () {
      api.rerender('151fcf52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/setting/mnemonic.vue"
export default component.exports